import React, { useRef } from 'react';
import CRBPrint from './CRBPrint';
import { IStore } from '../../../../../redux/store';
import { crbActions, crbSelectors } from '../../../../../redux/app/crb';
import { Dispatch } from 'redux';
import { TCRBHistoryFilters } from '../../../../../redux/app/crb/@types';
import { ConnectedProps, connect } from 'react-redux';
import CRBCoverPage from './CRBCoverPage';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';
import { getFilteredTanks } from 'redux/app/vessel/inspector/utils';
import TankWithPositionTable from 'components/app/vessel/onboard/inspector/_elements/TankWithPositionTable';
import { marpolSelectors } from 'redux/app/marpol';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type CRBHistoryProps = PropsFromRedux & OwnProps;

function CRBInspectorView(props: CRBHistoryProps) {
    const { historyList, showCoverPages, tanks, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    const filteredTanks = getFilteredTanks(tanks, 'type', [
        'CARGO_TANK',
        'SLOP_TANK',
    ]);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? (
                <CRBCoverPage vesselId={vesselId}>
                    <div className="flex justify-center">
                        <TankWithPositionTable tanks={filteredTanks} />
                    </div>
                </CRBCoverPage>
            ) : null}

            <div className="py-4 newpage">
                <CRBPrint
                    key={'temp-print-id-crb'}
                    isPrintVisible={true}
                    crbRecords={historyList}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const crbRecordStore = crbSelectors._getStore(store);
    const marpolStore = marpolSelectors._getStore(store);
    const tanks = marpolSelectors.getTanks(marpolStore);

    return {
        historyList: crbSelectors.getHistoryList(crbRecordStore),
        jobToLoadHistory: crbSelectors.jobToLoadHistory(crbRecordStore),
        tanks,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {
        load(filters: TCRBHistoryFilters) {
            return dispatch(crbActions.commands.historyLoad(filters));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(CRBInspectorView);
